import { render, staticRenderFns } from "./VetPersonalDetails.vue?vue&type=template&id=27a6fad0&"
import script from "./VetPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./VetPersonalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports